import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ButtonCategory } from 'src/app/shared/components/button/button.types';
import { HeadingType } from 'src/app/shared/components/heading/heading.types';

@Component({
  selector: 'app-confirmation-popover',
  templateUrl: './confirmation-popover.component.html',
  styleUrls: ['./confirmation-popover.component.scss'],
})
export class ConfirmationPopoverComponent {
  @Input() props: {
    header: {
      text: string;
      level?: HeadingType;
      icon?: string;
    };
    description?: string[];
    buttons?: { text: string; type: ButtonCategory; handler: any }[];
  };

  constructor(public popoverCtrl: PopoverController) {}
}
